import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 16:39:19
 * @LastEditTime: 2021-12-02 15:23:08
 * @LastEditors: wangshengqiang
 * @Description:  受益人信息确认
 */
import React from 'react';
import { cloneDeep } from 'lodash';
import { isPreviewMode } from '@/utils/tool';
import ConfirmInfoTitle from '@/components/ConfirmOrderInfo/ConfirmInfoTitle';
import { useStore } from '@/store';
import Detail from './Detail';
import FieldValue from './FieldValue';
import './index.less';
export default function BeneficiaryDetail(props) {
  const {
    attrs,
    label
  } = props;
  const {
    isDefault
  } = attrs;
  let {
    dataSource
  } = attrs;
  dataSource = dataSource.filter(item => item.isDefault === true);
  let content = [];
  const {
    insuredList = []
  } = useStore('orderDetail') || {};

  const _insuredList = cloneDeep(insuredList);

  if (!_insuredList && !isPreviewMode()) {
    return null;
  }

  if (isDefault === false) return null;

  if (isPreviewMode()) {
    var _dataSource;

    content = /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, (_dataSource = dataSource) === null || _dataSource === void 0 ? void 0 : _dataSource.map((item, index) => /*#__PURE__*/React.createElement(Detail, {
      label: item.label
    })));
  } else {
    content = _insuredList === null || _insuredList === void 0 ? void 0 : _insuredList.filter(ins => ins.allowInsure !== false && ins.selected === true) // 过滤不符合的被保人
    .map((ins = {}, index) => {
      var _ins$person, _ins$beneficiaryList2;

      if (ins.beneficiaryType === 'legalBeneficiary') {
        var _ins$beneficiaryList;

        (_ins$beneficiaryList = ins.beneficiaryList) === null || _ins$beneficiaryList === void 0 ? void 0 : _ins$beneficiaryList.push({
          person: {
            beneficiaryType: 'legalBeneficiary'
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "content"
      }, _insuredList.length > 1 && /*#__PURE__*/React.createElement(Detail, {
        label: `被保人${index + 1}`,
        value: ins === null || ins === void 0 ? void 0 : (_ins$person = ins.person) === null || _ins$person === void 0 ? void 0 : _ins$person.name
      }), (_ins$beneficiaryList2 = ins.beneficiaryList) === null || _ins$beneficiaryList2 === void 0 ? void 0 : _ins$beneficiaryList2.map((bene, i) => /*#__PURE__*/React.createElement(DetailItem, {
        index: i,
        data: bene,
        dataSource: dataSource
      })));
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "c-beneficiary-detail c-InfoConfirm bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(ConfirmInfoTitle, {
    title: label
  })), content);
} // 受益人

function DetailItem(props) {
  const {
    index,
    data,
    dataSource = []
  } = props;
  const {
    person = {}
  } = data; // 是否法定受益人

  const isLegal = !person.beneficiaryType || person.beneficiaryType === 'legalBeneficiary';

  if (isLegal) {
    const typeConfig = dataSource === null || dataSource === void 0 ? void 0 : dataSource.find(item => item.value === 'beneficiaryType');
    return /*#__PURE__*/React.createElement("div", {
      className: "nJfhj apNhd hair-line "
    }, /*#__PURE__*/React.createElement(FieldValue, _extends({
      key: index,
      data: person
    }, typeConfig)));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "nJfhj hair-line"
  }, /*#__PURE__*/React.createElement("p", null, "\u53D7\u76CA\u4EBA", index + 1), dataSource === null || dataSource === void 0 ? void 0 : dataSource.map((item, i) => /*#__PURE__*/React.createElement(FieldValue, _extends({
    key: i,
    data: person
  }, item))));
}